import { useCallback } from 'react';
import { Button, Heading, List } from 'yoso';
import { useLogin } from '~/components/Auth';
import { BaseCard } from '~/components/Card';
import { useEmbeddedViewer } from '~/components/Embedded/Embedded.hooks';
import { T } from '~/components/I18n';
import { BlueWallet } from '~/components/Icon/BlueWallet';
import checkBlue from '~/components/Icon/checkBlue.png';
import { useMember } from '~/components/Member/Member.hooks';
import { useVaultStatus } from '~/components/Wallet/Vault/Vault.hooks';
import { registerW8benUrl, useW8ben } from '~/components/Wallet/W8ben/W8ben.hooks';
import styles from './LandRequirement.module.scss';

export const LandRequirement = () => {
  const {
    data: { isLoggedIn },
  } = useMember();
  const {
    data: { registered: vaultRegistered, sellerInfoUrl },
    isFetching: isVaultFetching,
  } = useVaultStatus();
  const {
    data: { status: w8benStatus },
    isFetching: isW8benFetching,
  } = useW8ben();

  const { open } = useEmbeddedViewer();

  const login = useLogin();

  const onVaultButtonClick = useCallback(() => {
    if (isLoggedIn) {
      open(sellerInfoUrl);
    } else {
      login();
    }
  }, [isLoggedIn, login, open, sellerInfoUrl]);

  const onW8benButtonClick = useCallback(() => {
    if (isLoggedIn) {
      open(registerW8benUrl);
    } else {
      login();
    }
  }, [isLoggedIn, login, open]);

  return (
    <div className={styles.root}>
      <Heading level={4} className={styles.title}>
        <T name="citizen_land_guide_process_desc4_1" />
      </Heading>
      <List className={styles.list}>
        <li>
          <BaseCard shadow className={styles.card} size="large">
            <div className={styles.cardAside}>
              <BlueWallet className={styles.cardImage} />
            </div>
            <div className={styles.cardBody}>
              <Heading level={5} className={styles.cardTitle}>
                <T name="citizen_land_detail_guide_banner2_title" />
              </Heading>
              <p className={styles.cardDescription}>
                <T name="citizen_land_detail_guide_banner2_desc1" />
              </p>
              <Button
                className={styles.cardButton}
                disabled={isVaultFetching || vaultRegistered}
                onClick={onVaultButtonClick}
                size="small">
                {vaultRegistered ? (
                  <T name="citizen_button_title_connected" />
                ) : (
                  <T name="citizen_button_title_not_connected" />
                )}
              </Button>
            </div>
          </BaseCard>
        </li>
        <li>
          <BaseCard shadow className={styles.card} size="large">
            <div className={styles.cardAside}>
              <img
                src={checkBlue}
                alt="check blue"
                className={styles.cardImage}
                width={130}
                height={130}
              />
            </div>
            <div className={styles.cardBody}>
              <Heading level={5} className={styles.cardTitle}>
                <T name="citizen_land_w8ben_check_title" />
              </Heading>
              <p className={styles.cardDescription}>
                <T name="citizen_land_detail_w8ben_banner_desc" />
              </p>
              <Button
                className={styles.cardButton}
                disabled={isW8benFetching || w8benStatus === 'REGISTERED'}
                onClick={onW8benButtonClick}
                size="small">
                {w8benStatus === 'REGISTERED' ? (
                  <T name="citizen_button_title_registered" />
                ) : (
                  <T name="citizen_button_title_not_registered" />
                )}
              </Button>
            </div>
          </BaseCard>
        </li>
      </List>
    </div>
  );
};
